export enum CameraTypeEnum {
  SCAN = 'scan',
  SNAPSHOT = 'snapshot'
}
